import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";

const dropdownNavLinkStyle = {
  textDecoration: "none",
  color: "#dee2e6",
};

function HeaderItem({ label, to, onClick }) {
  return (
    <Dropdown.Item
      as={Link}
      to={to || ""}
      className="textoNav"
      style={dropdownNavLinkStyle}
      onClick={onClick}
    >
      {label}
    </Dropdown.Item>
  );
}

export default HeaderItem;
